import { useState } from 'react';
import { UserProfileForm } from '@/components/profile/UserProfileForm';
import { UserNotificationPreferencesForm } from '@/components/profile/UserNotificationPreferencesForm';
import Card from '@/components/common/Card';

// Tab type definition
type TabType = 'profile' | 'notifications';

export const UserProfilePage = () => {
  const [activeTab, setActiveTab] = useState<TabType>('profile');
  
  // Tab definitions
  const tabs: { id: TabType; name: string }[] = [
    { id: 'profile', name: 'Profile' },
    { id: 'notifications', name: 'Notifications' }
  ];
  
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <h1 className="text-3xl font-bold mb-6">My Profile</h1>
      
      <Card className="mb-6">
        <div className="border-b border-gray-200">
          <nav className="flex -mb-px">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                className={`
                  py-4 px-6 border-b-2 font-medium text-sm
                  ${activeTab === tab.id
                    ? 'border-primary text-primary'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}
                `}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.name}
              </button>
            ))}
          </nav>
        </div>
      </Card>
      
      <div className="space-y-6">
        {activeTab === 'profile' && (
          <UserProfileForm />
        )}
        
        {activeTab === 'notifications' && (
          <UserNotificationPreferencesForm />
        )}
      </div>
    </div>
  );
}; 